import {
  COMMUNITY_POST_STATUS,
  COMMUNITY_POST_TYPES,
} from "../enums/CommunityPost";

export const COMMUNITY_POST_STATUS_CHOICES = [
  {
    id: COMMUNITY_POST_STATUS.PUBLISHED,
    name: "Publicado",
  },
  {
    id: COMMUNITY_POST_STATUS.BANNED,
    name: "Baneado",
  },
  {
    id: COMMUNITY_POST_STATUS.HIDDEN,
    name: "Oculto",
  },
];

export const COMMUNITY_POST_TYPES_CHOICES = [
  {
    id: COMMUNITY_POST_TYPES.FREE,
    name: "Libre",
  },
  {
    id: COMMUNITY_POST_TYPES.REVIEW,
    name: "Reseña",
  },
  {
    id: COMMUNITY_POST_TYPES.SURVEY,
    name: "Encuesta",
  },
];
